
import ClientsSlider from '../modules/components/_clients-slider';
import SeoSlider from '../modules/components/_seo-slider';
import hubspotServices from '../modules/components/_services-slider';
import Header from '../modules/components/_header';
import hero from '../modules/components/_hero';
import testimonial from '../modules/components/_testimonial';
// import smoothScroll from '../modules/components/_smooth-scroll';

const Components = {
    init() {
        ClientsSlider.init();
        hubspotServices.init();
        Header.init();
        hero.init();
        testimonial.init();
        SeoSlider.init();
    },
    finalize() {

    },
};
export default Components;



// WEBPACK FOOTER //
// ./scripts/autoload/_components.js